import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieBaremeIK } from "../../interface/regie";

export const setRegieBaremeIK = async (
  bracket: IRegieBaremeIK,
  token: string,
  setIK: (ik: IRegieBaremeIK[]) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.post(`${urlAPI}/regie/baremes/ik`, bracket, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setIK(response.data.message);
    dispatch(showSnackbar("Tranche de barème kilométrique mise à jour.", "success"));
  } catch (error: any) {
    console.error(error);
    setError(error?.response?.data?.error || "Impossible de mettre à jour cette tranche.");
    dispatch(showSnackbar("Erreur lors de la mise à jour de la tranche kilométrique.", "error"));
  }
};
